import type { SavedViewConfig, SortDirection } from "@/components/shared/UniversalCRMTable/types";
import { collectFieldsForSavedView } from "./collect-fields-for-saved-view";
import { COMMUNICATIONS_FIELDS, type CommunicationsFieldId } from "./communications-field-ids";

/**
 * Predefined saved views for the Communications table.
 *
 * `visibleColumns` is derived from each field's `savedViewMembership`
 * declaration via `collectFieldsForSavedView` — so adding or removing a
 * column from a view only requires touching the relevant field file.
 */
const visibleFor = (viewId: string): CommunicationsFieldId[] =>
  collectFieldsForSavedView<CommunicationsFieldId>(viewId, COMMUNICATIONS_FIELDS);

export const communicationsSavedViews: SavedViewConfig<CommunicationsFieldId>[] = [
  {
    id: "all-communications",
    name: "All Communications",
    filters: {},
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    visibleColumns: visibleFor("all-communications"),
  },
  {
    id: "recent-communications",
    name: "Recent Communications",
    filters: {},
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    visibleColumns: visibleFor("recent-communications"),
  },
  // Communication type filters
  {
    id: "type-email",
    name: "Email",
    filters: { type_label: "Email" },
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    visibleColumns: visibleFor("type-email"),
  },
  {
    id: "type-note",
    name: "Note",
    filters: { type_label: "Note" },
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    visibleColumns: visibleFor("type-note"),
  },
  {
    id: "type-call",
    name: "Call",
    filters: { type_label: "Call" },
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    visibleColumns: visibleFor("type-call"),
  },
  {
    id: "type-meeting",
    name: "Meeting",
    filters: { type_label: "Meeting" },
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    visibleColumns: visibleFor("type-meeting"),
  },
  {
    id: "type-text",
    name: "Text Messages",
    // type_label is denormalized from communication_types.label ("Text Message").
    filters: { type_label: "Text Message" },
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    // Reuse the call view's column set (identical layout for a message type).
    visibleColumns: visibleFor("type-call"),
  },
  // Direction filters
  {
    id: "outbound-communications",
    name: "Outbound Communications",
    filters: { direction: "outbound" },
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    visibleColumns: visibleFor("outbound-communications"),
  },
  {
    id: "inbound-communications",
    name: "Inbound Communications",
    filters: { direction: "inbound" },
    sort: { field: "occurred_at", direction: "desc" as SortDirection },
    visibleColumns: visibleFor("inbound-communications"),
  },
];

// Custom filter hooks for saved views (can be populated later if needed)
export const communicationsCustomFilterHooks = {};
